import { Box, Typography } from "@material-ui/core";
import { FC } from "react";

const ImageWithText: FC<ImageWithTextProps> = ({ height = "100%", src, message }) => {
  return (
    <Box height={height} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
      <Box width="150px">
        <img src={src} alt={message} style={{ width: "100%" }} />
      </Box>
      <Typography variant="h6" color="textSecondary">
        {message}
      </Typography>
    </Box>
  );
};

interface ImageWithTextProps {
  height?: string;
  src: any;
  message: string;
}

export default ImageWithText;
